import { render, staticRenderFns } from "./AppQuestionGroup.vue?vue&type=template&id=4c142db0&scoped=true"
import script from "./AppQuestionGroup.vue?vue&type=script&lang=ts"
export * from "./AppQuestionGroup.vue?vue&type=script&lang=ts"
import style0 from "./AppQuestionGroup.vue?vue&type=style&index=0&id=4c142db0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c142db0",
  null
  
)

export default component.exports